<template>
    <li class="item" @mouseover="getChild(model.childrens, $event)">
        <a v-if="!isDel" :href="model.url" :class="thisType">{{
            model.name
        }}</a>
        <ins v-if="isDel" class="item-del">Смотрите также:</ins>
        <span v-if="isFolder"></span>
    </li>
</template>

<script>
    var timerId;
    export default {
        props: {
            model: Object,
        },
        data() {
            return {
                open: false,
            };
        },
        computed: {
            isFolder() {
                return this.model.childrens && this.model.childrens.length;
            },
            thisType() {
                return this.model.type;
            },
            isDel() {
                return this.model.name === '.';
            },
            thisLevel() {
                return this.model.level;
            },
        },
        methods: {
            getChild(childrens, event) {
                var self = this;
                clearTimeout(timerId);
                timerId = setTimeout(function () {
                    $(event.target)
                        .parent('li')
                        .parent('div')
                        .find('li.active')
                        .removeClass('active');
                    $(event.target).parent('li').addClass('active');

                    if (self.thisLevel == 1) {
                        self.$store.commit('updateLevel', {
                            thislevel: 2,
                            list: null,
                            isCatalog: false,
                            parentUrl: null,
                        });
                        self.$store.commit('updateLevel', {
                            thislevel: 3,
                            list: null,
                            isCatalog: false,
                            parentUrl: null,
                        });
                        $('.submenu, .submenu2, .submenu3')
                            .find('li.active')
                            .removeClass('active');
                    }

                    if (self.thisLevel == 2) {
                        self.$store.commit('updateLevel', {
                            thislevel: 3,
                            list: null,
                            isCatalog: false,
                            parentUrl: null,
                        });
                        $('.submenu2, .submenu3')
                            .find('li.active')
                            .removeClass('active');
                        $('.menu-box-inn').animate({ scrollLeft: 5000 }, 300);
                    }

                    if (self.thisLevel == 3) {
                        $('.submenu3').find('li.active').removeClass('active');
                        $('.menu-box-inn').animate({ scrollLeft: 5000 }, 300);
                    }

                    self.$store.commit('updateLevel', {
                        thislevel: self.thisLevel,
                        list: self.model.childrens,
                        isCatalog: self.model.isCatalog,
                        parentUrl: self.model.url,
                    });
                }, 500);
            },
        },
    };
</script>
